import { Link } from 'react-router-dom';
import { HiOutlineExternalLink } from 'react-icons/hi';

export default function Card({ title, description, reflink }) {
  return (
    <div className='relative flex flex-col justify-between p-4 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700 '>
      <Link
        to={reflink}
        className='font-sans text-lg font-bold text-left md:text-2xl after:z-10 after:absolute after:inset-0 after:bg-transparent after:pointer-events-auto'
      >
        <div className='flex justify-between pb-4'>
          <h3>{title}</h3>
          <HiOutlineExternalLink className='relative flex space-x-2 text-lg md:text-2xl' />
        </div>
      </Link>
      <p className='font-serif text-sm text-left md:text-base'>{description}</p>
    </div>
  );
}
